export default __webpack_public_path__ + "static/media/62.15da19c5.jpg";